import { Form } from 'antd';
import { Button, Colors, IcPlus, InputSearch, Row, Text } from 'basic-ui-lib';
import useGetListStores from 'modules/store/services/hooks/useGetListStore';
import styled from 'styled-components';
import NewStoreModal, { useNewStoreModalRef } from 'modules/store/screens/Create/NewStoreModal';

const StoreFilter = () => {
  const [form] = Form.useForm();
  const newStoreModalRef = useNewStoreModalRef();

  const handleOpenModal = () => {
    newStoreModalRef.current?.open();
  };
  const { storesList} = useGetListStores(true);
  return (
    <Container>
      <Form form={form} layout='vertical' className='form-container'>
        <Row width='45%'>
          <Text title_h2 semibold>
            Stores ({storesList?.totalElements || 0})
          </Text>
        </Row>
        <Row gap={16} width='55%' justifyContent='flex-end'>
          <Form.Item name='keySearch' noStyle className='input-search'>
            <InputSearch placeholder='Search business name/phone' />
          </Form.Item>
          <Button 
            type_second 
            lg 
            type='button' 
            prefix={<IcPlus fill={Colors.neutral.bg[1]} width={20} height={20} />}
            onClick={handleOpenModal}
          >
            Add Store
          </Button>
        </Row>
      </Form>

      <NewStoreModal ref={newStoreModalRef} />
    </Container>
  );
};

export default StoreFilter;

const Container = styled.div`
  width: 100%;

  .form-container {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .custom-text {
    white-space: nowrap;
  }

  .input-search {
    width: 490px;
  }
`;
